import axios from 'axios';
import * as types from './AdminApparelItemParts.types';
import { showNotification } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as selectors from './AdminApparelItemParts.selectors';
import * as dialog from './../common/dialog';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchApparelItem = (id) => (dispatch, getState) => {
    dispatch({ type: types.FETCH_APPAREL_ITEM, payload: null });
    axios.get(apiUrl + '/uthealth-apparel-item/' + id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_APPAREL_ITEM_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_APPAREL_ITEM_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const fetchApparelItemParts = (id) => (dispatch, getState) => {
    const pagination = selectors.getPagination(getState());
    const sort = selectors.getSort(getState());
    const search = selectors.getSearch(getState());
    const searchType = selectors.getSearchType(getState());

    let params = [];
    params.push('active-page=' + pagination.activePage);
    params.push('elements-per-page=' + pagination.elementsPerPage);
    params.push('sort-column=' + sort.column);
    params.push('sort-type=' + sort.type);
    params.push('search=' + search);
    params.push('search-type=' + searchType);

    dispatch({ type: types.FETCH_APPAREL_ITEM_PARTS, payload: null });
    axios.get(apiUrl + '/uthealth-apparel-item/admin-parts-index?id=' + id + '&' + params.join('&'),
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_APPAREL_ITEM_PARTS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_APPAREL_ITEM_PARTS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const saveApparelItemPart = () => (dispatch, getState) => {
    const apparelItemPart = selectors.getApparelItemPart(getState());
    const itemId = selectors.getItemId(getState());

    if (apparelItemPart.sku === undefined || apparelItemPart.sku == null || apparelItemPart.sku === '') {
        return showNotification('Complete information', 'Enter the Sku for the item', 'info');
    }
    if (apparelItemPart.size === undefined || apparelItemPart.size == null || apparelItemPart.size === '') {
        return showNotification('Complete information', 'Select the Size for the item', 'info');
    }
    if (apparelItemPart.logo === undefined || apparelItemPart.logo == null || apparelItemPart.logo === '') {
        return showNotification('Complete information', 'Select the Logo for the item', 'info');
    }
    if (apparelItemPart.lead_time === undefined || apparelItemPart.lead_time == null || apparelItemPart.lead_time === '') {
        return showNotification('Complete information', 'Select the Lead Time for the item', 'info');
    }
    if (apparelItemPart.inventory === undefined || apparelItemPart.inventory == null || apparelItemPart.inventory === '') {
        return showNotification('Complete information', 'Enter the Inventory for the item', 'info');
    }
    if (apparelItemPart.blank_cost === undefined || apparelItemPart.blank_cost == null || apparelItemPart.blank_cost === '') {
        return showNotification('Complete information', 'Enter the Blank Cost for the item', 'info');
    }
    if (apparelItemPart.decoration_cost === undefined || apparelItemPart.decoration_cost == null || apparelItemPart.decoration_cost === '') {
        return showNotification('Complete information', 'Enter the Decoration Cost for the item', 'info');
    }
    if (apparelItemPart.customization_charge === undefined || apparelItemPart.customization_charge == null || apparelItemPart.customization_charge === '') {
        return showNotification('Complete information', 'Enter the Customization Charge for the item', 'info');
    }
    if (apparelItemPart.markup_parsed === undefined || apparelItemPart.markup_parsed == null || apparelItemPart.markup_parsed === '') {
        return showNotification('Complete information', 'Enter the Markup for the item', 'info');
    }
    if (apparelItemPart.sku_charge === undefined || apparelItemPart.sku_charge == null || apparelItemPart.sku_charge === '') {
        return showNotification('Complete information', 'Enter the SKU Charge for the item', 'info');
    }
    if (apparelItemPart.shipping_charge === undefined || apparelItemPart.shipping_charge == null || apparelItemPart.shipping_charge === '') {
        return showNotification('Complete information', 'Enter the Shipping Charge for the item', 'info');
    }

    let endpoint = null;
    if (apparelItemPart.id && apparelItemPart.id !== '') {
        endpoint = apiUrl + '/uthealth-apparel-item/update-part';
    } else {
        endpoint = apiUrl + '/uthealth-apparel-item/create-part';
    }

    var formData = new FormData();
    formData.append('itemId', itemId);
    formData.append('id', apparelItemPart.id);
    formData.append('sku', apparelItemPart.sku);
    formData.append('size', apparelItemPart.size);
    formData.append('logo', apparelItemPart.logo);
    formData.append('lead_time', apparelItemPart.lead_time);
    formData.append('inventory', apparelItemPart.inventory);
    formData.append('blank_cost', apparelItemPart.blank_cost);
    formData.append('decoration_cost', apparelItemPart.decoration_cost);
    formData.append('customization_charge', apparelItemPart.customization_charge);
    formData.append('markup_parsed', apparelItemPart.markup_parsed);
    formData.append('rack', apparelItemPart.rack && apparelItemPart.rack != null ? apparelItemPart.rack : '');
    formData.append('row', apparelItemPart.row && apparelItemPart.row != null ? apparelItemPart.row : '');
    formData.append('bin', apparelItemPart.bin && apparelItemPart.bin != null ? apparelItemPart.bin : '');
    formData.append('weight', apparelItemPart.weight && apparelItemPart.weight != null ? apparelItemPart.weight : '');
    formData.append('pieces_per_package', apparelItemPart.pieces_per_package && apparelItemPart.pieces_per_package != null ? apparelItemPart.pieces_per_package : '');
    formData.append('sku_charge', apparelItemPart.sku_charge);
    formData.append('shipping_charge', apparelItemPart.shipping_charge);

    dispatch({ type: types.SAVE_APPAREL_ITEM_PART, payload: null });
    axios.post(endpoint, formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.SAVE_APPAREL_ITEM_PART_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('form-modal'));
            showNotification('Part Saved', 'The part has been saved successfully', 'success');
            dispatch(fetchApparelItemParts(itemId));
            dispatch(resetApparelItemPart());
        })
        .catch((error) => {
            dispatch({ type: types.SAVE_APPAREL_ITEM_PART_ERROR, payload: null });
            if (error.response && (error.response.status === 409)) {
                showNotification('Part exists', 'The part is in the system already', 'warning');
            } else if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const deleteApparelItemPart = () => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());
    const sizeModal = selectors.getSizeModal(getState());
    const logoModal = selectors.getLogoModal(getState());
    const itemId = selectors.getItemId(getState());

    dispatch({ type: types.DELETE_APPAREL_ITEM_PART, payload: null });
    axios.delete(apiUrl + '/uthealth-apparel-item/delete-part?itemId=' + itemId + '&sku=' + idModal + '&size=' + sizeModal + '&logo=' + logoModal,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.DELETE_APPAREL_ITEM_PART_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('delete-modal'));
            showNotification('Part Deleted', 'The part has been deleted successfully', 'success');
            dispatch(fetchApparelItemParts(itemId));
        })
        .catch((error) => {
            dispatch({ type: types.DELETE_APPAREL_ITEM_PART_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const generateParts = () => (dispatch, getState) => {
    const apparelItemPart = selectors.getApparelItemPart(getState());
    const itemId = selectors.getItemId(getState());
    const selectedSizes = selectors.getSelectedSizes(getState());
    const selectedLogos = selectors.getSelectedLogos(getState());

    if (selectedSizes.length === 0) {
        return showNotification('Complete information', 'Select at least one size', 'info');
    }
    if (apparelItemPart.lead_time === undefined || apparelItemPart.lead_time == null || apparelItemPart.lead_time === '') {
        return showNotification('Complete information', 'Select the Lead Time for the item', 'info');
    }
    if (apparelItemPart.inventory === undefined || apparelItemPart.inventory == null || apparelItemPart.inventory === '') {
        return showNotification('Complete information', 'Enter the Inventory for the item', 'info');
    }
    if (apparelItemPart.blank_cost === undefined || apparelItemPart.blank_cost == null || apparelItemPart.blank_cost === '') {
        return showNotification('Complete information', 'Enter the Blank Cost for the item', 'info');
    }
    if (apparelItemPart.decoration_cost === undefined || apparelItemPart.decoration_cost == null || apparelItemPart.decoration_cost === '') {
        return showNotification('Complete information', 'Enter the Decoration Cost for the item', 'info');
    }
    if (apparelItemPart.customization_charge === undefined || apparelItemPart.customization_charge == null || apparelItemPart.customization_charge === '') {
        return showNotification('Complete information', 'Enter the Customization Charge for the item', 'info');
    }
    if (apparelItemPart.markup_parsed === undefined || apparelItemPart.markup_parsed == null || apparelItemPart.markup_parsed === '') {
        return showNotification('Complete information', 'Enter the Markup for the item', 'info');
    }
    if (apparelItemPart.sku_charge === undefined || apparelItemPart.sku_charge == null || apparelItemPart.sku_charge === '') {
        return showNotification('Complete information', 'Enter the SKU Charge for the item', 'info');
    }
    if (apparelItemPart.shipping_charge === undefined || apparelItemPart.shipping_charge == null || apparelItemPart.shipping_charge === '') {
        return showNotification('Complete information', 'Enter the Shipping Charge for the item', 'info');
    }

    const logos = [...selectedLogos];
    if (logos.length === 0) {
        logos.push(0);
    }

    var values = {
        item_id: itemId,
        lead_time: apparelItemPart.lead_time,
        inventory: apparelItemPart.inventory,
        blank_cost: apparelItemPart.blank_cost,
        decoration_cost: apparelItemPart.decoration_cost,
        customization_charge: apparelItemPart.customization_charge,
        markup_parsed: apparelItemPart.markup_parsed,
        rack: apparelItemPart.rack && apparelItemPart.rack != null ? apparelItemPart.rack : '',
        row: apparelItemPart.row && apparelItemPart.row != null ? apparelItemPart.row : '',
        bin: apparelItemPart.bin && apparelItemPart.bin != null ? apparelItemPart.bin : '',
        weight: apparelItemPart.weight && apparelItemPart.weight != null ? apparelItemPart.weight : '',
        pieces_per_package: apparelItemPart.pieces_per_package && apparelItemPart.pieces_per_package != null ? apparelItemPart.pieces_per_package : '',
        sku_charge: apparelItemPart.sku_charge,
        shipping_charge: apparelItemPart.shipping_charge,
        selected_sizes: selectedSizes,
        selected_logos: logos,
    };

    dispatch({ type: types.GENERATE_PARTS, payload: null });
    axios.post(apiUrl + '/uthealth-apparel-item/generate-parts', values,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.GENERATE_PARTS_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('generate-modal'));
            showNotification('Parts Generated', 'The parts has been generated successfully', 'success');
            dispatch(fetchApparelItemParts(itemId));
        })
        .catch((error) => {
            dispatch({ type: types.GENERATE_PARTS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setIdModal = (size, logo, sku) => (dispatch) => {
    dispatch({
        type: types.SET_ID_MODAL,
        payload: { size, logo, sku }
    });
}

export const setActivePage = (value) => (dispatch, getState) => {
    const itemId = selectors.getItemId(getState());
    new Promise(resolve => {
        dispatch({
            type: types.SET_ACTIVE_PAGE,
            payload: value,
        });
        resolve();
    }).then(() => {
        dispatch(fetchApparelItemParts(itemId));
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}

export const setApparelItemPartField = (field, value) => (dispatch) => {
    dispatch({
        type: types.SET_APPAREL_ITEM_PART_FIELD,
        payload: { field, value },
    })
}

export const setApparelItemPart = (sku) => (dispatch, getState) => {
    const apparelItemParts = selectors.getApparelItemParts(getState());

    let selectedItem = null;
    for (const apparelItemPart of apparelItemParts) {
        if (apparelItemPart.sku === sku) {
            selectedItem = apparelItemPart;
            break;
        }
    }

    dispatch({
        type: types.SET_APPAREL_ITEM_PART,
        payload: selectedItem,
    })
}

export const resetApparelItemPart = () => (dispatch) => {
    dispatch({
        type: types.RESET_APPAREL_ITEM_PART,
        payload: {},
    })
}

export const setSort = (column, type) => (dispatch, getState) => {
    const itemId = selectors.getItemId(getState());
    new Promise(resolve => {
        dispatch({
            type: types.SET_SORT,
            payload: { column, type }
        });
        resolve();
    }).then(() => {
        dispatch(fetchApparelItemParts(itemId));
    });
}

export const setSearch = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH,
        payload: value,
    });
}

export const setSearchType = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH_TYPE,
        payload: value,
    });
}

export const setItemId = (value) => dispatch => {
    dispatch({
        type: types.SET_ITEM_ID,
        payload: value,
    });
}

export const checkSize = (size, value) => dispatch => {
    dispatch({
        type: types.CHECK_SIZE,
        payload: { size, value },
    });
}

export const checkLogo = (logo, value) => dispatch => {
    dispatch({
        type: types.CHECK_LOGO,
        payload: { logo, value },
    });
}